<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>賦能-Solution</h2>
            <h2 *ngIf="info !== '商業智慧與預測分析BI and AI'" style="padding-top: 10px;">{{info}}</h2>
            <h2 *ngIf="info === '商業智慧與預測分析BI and AI'" style="padding-top: 10px;">商業智慧與預測分析BI & AI</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Services Details Area -->
<section class="services-details-area ptb-100" style="padding-top: 50px;">
    <div class="container" style="max-width: 80%;">
        <div class="services-details-overview"
            style="justify-content: space-evenly;align-items: center; padding-top: 15px;">

            <div class="services-details-desc">
                <h3 [style.color]="textcolor">{{firstTitle}}</h3>
                <p [innerHTML]="firstContent"></p>
            </div>
            <img [src]="firstImg" alt="image" class="solution-details-pic">
            <!-- <div class="services-details-image wow fadeInUp">
                <img [src]="firstImg" alt="image">
            </div> -->
        </div>

        <div class="services-details-overview"
            style="justify-content: space-evenly;align-items: center; padding-top: 15px;">

            <!-- <div class="services-details-image wow fadeInUp">
                <img [src]="secondImg" alt="image">
            </div> -->
            <img [src]="secondImg" alt="image" class="solution-details-pic">
            <div class="services-details-desc" style="padding-top: 15px;">
                <h3 [style.color]="textcolor">{{secondTitle}}</h3>
                <p [innerHTML]="secondContent"></p>
            </div>
        </div>

        <div class="services-details-overview"
            style="justify-content: space-evenly;align-items: center; padding-top: 15px;"
            *ngIf="info === '顧客管理 CRM 與客戶體驗 CX' || info === '企業防疫營運不中斷戰術'">
            <div class="services-details-desc" style="padding-top: 15px;">
                <h3 [style.color]="textcolor">{{thirdTitle}}</h3>
                <p [innerHTML]="thirdContent"></p>
            </div>
            <img [src]="thirdImg" alt="image" class="solution-details-pic">
        </div>

        <div class="services-details-overview"
            style="justify-content: space-evenly;align-items: center; padding-top: 15px;"
            *ngIf="info === '顧客管理 CRM 與客戶體驗 CX' || info === '企業防疫營運不中斷戰術'">
            <img [src]="fourthImg" alt="image" class="solution-details-pic">
            <div class="services-details-desc" style="padding-top: 15px;">
                <h3 [style.color]="textcolor">{{fourthTitle}}</h3>
                <p [innerHTML]="fourthContent"></p>
            </div>
        </div>
    </div>
</section>
<div class="container covid" style="padding-bottom: 110px;" *ngIf="info === '企業防疫營運不中斷戰術'">
    <h4 style="line-height: 1.8;font-size: 20px;color: black;">Covid-19
        特殊期間，企業防疫營運不中斷戰術將不定時更新，若想收到最新消息，請點選下方訂閱，將第一時間通知更新，或來信/來電與專人聯繫~碩達系統與您一同抗疫，為企業加油!!!</h4>

    <app-subscribe></app-subscribe>
</div>
<!-- Start Serve Area -->
<section class="serve-area" *ngIf="info === '企業資源規劃 ERP 與 數位核心 Digital Platform'">
    <div class="container">

        <div class="row">

            <div class="col-6 col-lg-3 col-md-6 col-sm-3">
                <div class="solution-info-box">
                    <div>
                        <img src="assets/img/solution-details/icon_pic_11.png">
                    </div>
                    <h3>財務會計</h3>
                </div>
            </div>

            <div class="col-6 col-lg-3 col-md-6 col-sm-3">
                <div class="solution-info-box">
                    <div>
                        <img src="assets/img/solution-details/icon_pic_12.png">
                    </div>
                    <h3>供應鏈</h3>
                </div>
            </div>

            <div class="col-6 col-lg-3 col-md-6 col-sm-3">
                <div class="solution-info-box">
                    <div>
                        <img src="assets/img/solution-details/icon_pic_13.png">
                    </div>
                    <h3>生產製造</h3>
                </div>
            </div>

            <div class="col-6 col-lg-3 col-md-6 col-sm-3">
                <div class="solution-info-box">
                    <div>
                        <img src="assets/img/solution-details/icon_pic_14.png">
                    </div>
                    <h3>研發和工程</h3>
                </div>
            </div>

            <div class="col-6 col-lg-3 col-md-6 col-sm-3">
                <div class="solution-info-box">
                    <div>
                        <img src="assets/img/solution-details/icon_pic_15.png">
                    </div>
                    <h3>訂單銷售</h3>
                </div>
            </div>

            <div class="col-6 col-lg-3 col-md-6 col-sm-3">
                <div class="solution-info-box">
                    <div>
                        <img src="assets/img/solution-details/icon_pic_16.png">
                    </div>
                    <h3>流程管理</h3>
                </div>
            </div>

            <div class="col-6 col-lg-3 col-md-6 col-sm-3">
                <div class="solution-info-box">
                    <div>
                        <img src="assets/img/solution-details/icon_pic_17.png">
                    </div>
                    <h3>採購與合約</h3>
                </div>
            </div>

            <div class="col-6 col-lg-3 col-md-6 col-sm-3">
                <div class="solution-info-box">
                    <div>
                        <img src="assets/img/solution-details/icon_pic_18.png">
                    </div>
                    <h3>其他整合功能</h3>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Start Team Area -->
<section class="team-area ptb-100 pt-0" *ngIf="info !== '顧客管理 CRM 與客戶體驗 CX' && info !== '企業防疫營運不中斷戰術'">
    <div class="container" style="max-width: 100%;">
        <div class="section-title">
            <h2 [style.color]="textcolor" style="font-size: 35px;">{{subTitle1}}</h2>
            <p style="color: black;font-size: 25px;">{{subTitle2}}</p>
            <p style="margin-top: 0px;color: black;font-size: 25px;">{{subTitle3}}</p>
            <br>
            <img [src]="subTitleImg" class="pic15">
        </div>
    </div>

    <div class="container" style="max-width: 80%;">
        <div class="services-details-overview" *ngIf="info === '企業資源規劃 ERP 與 數位核心 Digital Platform'"
            style="justify-content: space-evenly;align-items: center; padding-top: 15px;">
            <div class="services-details-desc">
                <h3 [style.color]="textcolor">{{footerTitle}}</h3>
                <p [innerHTML]="footerContent"></p>
            </div>
            <img [src]="footerImg" alt="image" class="solution-details-pic">
            <!-- <div class="services-details-image wow fadeInUp" style="margin-bottom: 30px;">
            <img [src]="footerImg" alt="image">
        </div> -->
        </div>
    </div>
</section>
<!-- End Services Details Area -->
